import {Injectable} from '@angular/core';
import {Storager} from './storager';

@Injectable({
  providedIn: 'root'
})
export class LocalStoragerService implements Storager {

  public setElement(key: string, obj: any, encoded?: boolean) {
    let jsonObj = JSON.stringify(obj);
    if (encoded) {
      jsonObj = btoa(jsonObj);
    }
    localStorage.setItem(key, jsonObj);
  }

  public getElement(key: string, encoded?: boolean): any {
    let element = localStorage.getItem(key);
    if (!!element) {
      if (encoded) {
        element = atob(element);
      }
      return JSON.parse(element);
    }
    return;
  }

  public removeElement(key: string) {
    localStorage.removeItem(key);
  }

  public clearAll() {
    localStorage.clear();
  }

  public hasElement(key: string): boolean {
    return !!(localStorage.getItem(key));
  }

}
